


















import api from '@/lib/api'
import Vue from 'vue'
import { debounce } from 'lodash';
export default Vue.extend({
    props: {
        startingTags: Array
    },
    data(){
        return {
            tag_insert: '',
            nothing: false,
            tag_results: [] as string[],
            selected_tags: new Set<string>()
        }
    },
    beforeMount(){

        this.$props.startingTags.forEach((tag: string) => {
            this.selected_tags.add(tag)
        });

    },
    methods: { 
        removeTag(tag: string){
            this.selected_tags.delete(tag)
            this.closeTagsModal();
        },
        closeTagsModal(){
            this.tag_results = [];
            this.tag_insert = ''
            this.nothing = false
            this.$emit('update', this.selected_tags);
        },
        async selectTag(name: string){

            this.selected_tags.add(name);
            this.closeTagsModal();

        },  
        async addTag(){
            
            const resp = await api.media.tags.add(this.tag_insert);
            if(resp.err) return alert("di' a cippi che è successo un casino");

            this.selected_tags.add(this.tag_insert);
            this.closeTagsModal();

        },
        search: debounce(async function(this: any){
            
            this.nothing = false
            if(this.tag_insert.trim() === ""){
                return this.tag_results = []
            }
            const response = await api.media.tags.search(this.tag_insert);
            if(response.err) return alert("di' a cippi che è successo un casino");
            
            this.tag_results = response.ok!.value;
            this.nothing = response.ok!.value.length === 0;

        }, 300)
    }
})
